import BannerStandImage from './banner-stand-image';
import { ListStatus, EditableStatus } from '@/store/types';

export enum BannerStandImagesActions {
  LOAD_ALL = 'LOAD_ALL',
  LOAD_EDITABLE = 'LOAD_EDITABLE',
  CREATE = 'CREATE',
  SAVE = 'SAVE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  APPLY_FILTERS = 'APPLY_FILTERS',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  LOAD_PRODUCTS = 'LOAD_PRODUCTS',
  LOAD_USED_PRODUCTS = 'LOAD_USED_PRODUCTS',
  LOAD_EXISTING_LANGUAGES = 'LOAD_EXISTING_LANGUAGES',
}

export enum BannerStandImagesMutations {
  SET_ALL = 'SET_ALL',
  SET_ALL_STATUS = 'SET_ALL_STATUS',
  SET_EDITABLE = 'SET_EDITABLE',
  SET_EDITABLE_STATUS = 'SET_EDITABLE_STATUS',
  SET_LIST_PAGINATION = 'SET_LIST_PAGINATION',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  UPDATE_INITIAL_EDITABLE = 'UPDATE_INITIAL_EDITABLE',
  SET_PRODUCTS = 'SET_PRODUCTS',
  SET_USED_PRODUCTS = 'SET_USED_PRODUCTS',
  SET_EXISTING_LANGUAGES = 'SET_EXISTING_LANGUAGES',
}

export interface BannerStandImagesState {
  list: BannerStandImage[];
  listStatus: ListStatus;
  listPagination: {
    currentPage: number;
    lastPage: number;
    total: number;
  };
  editable: BannerStandImage | null;
  initialEditable: BannerStandImage | null;
  editableStatus: EditableStatus;
  products: { id: number; title: string }[];
  usedProducts: number[];
  existingLanguages: string[];
}

export interface BannerStandImagesFilters {
  search?: string;
  status?: number;
  product_id?: number;
  page?: number;
}

